// Disabled links
$(document).on("click", "a[disabled]", function(e) {
	e.preventDefault();
	e.stopPropagation();
	e.stopImmediatePropagation();
});

// Attach dynamic click listeners
$(document).on("click", "[data-trigger=click]", function(e) {

    if ($(this).data()["preventDefault"]) {
        e.preventDefault();
    }

    var params = [];

    if ($(this).attr("data-params")) {
        params = eval("[" + $(this).attr("data-params") + "]");
    }

    params.push(e);

    var controller = eval($(this).attr("data-controller"));
    controller.apply(this, params);
});

$('.menu-toggle').on('click', function() {
  $(this).toggleClass('is-active');
  $(document.body).toggleClass('nav-show')
});

$('.main-nav__child-toggler').on('click', function(e) {
    e.preventDefault();
    $(this).closest(".main-nav__item--has-childrens").toggleClass('main-nav__item--has-childrens-open');
});

if ($(".gallery--picture").length) {
    // Photoswipe init        
    $(".gallery--picture").photoSwipe(
        ".gallery__item-container",
        {
            bgOpacity: 0.8,
            shareEl: false,
            captionEl: false,
            tapToClose: true
        }
    );
}


$.fn.lastWord = function() {
  var text = this.text().trim().split(" ");
  var last = text.pop();
  this.html(text.join(" ") + (text.length >= 0 ? " <span class='last'>" + last + "</span>" : last));
};

$(".static-page h1").lastWord();
$(".about-us h1").lastWord();
$(".about-team h1").lastWord();
$(".services h1").lastWord();
$(".recommendations h1").lastWord();
$(".row--form h1").lastWord();

$(function(){
    $(".twentytwenty-container").twentytwenty();
  });